export const OPEN_DIALOGBOX = 'OPEN_DIALOGBOX';
export const CLOSE_DIALOGBOX = 'CLOSE_DIALOGBOX';